<template>
  <footer class="bg-white text-black py-12">
    <div class="container mx-auto px-6 lg:px-20 mt-4">
      <div class="flex flex-col lg:flex-row justify-between space-y-8 lg:space-y-0 lg:space-x-8">
        <div class="flex-1">
          <img src="@/assets/logo1.png" alt="Logo da OverX" class="w-auto h-14 mb-4" />
          <p class="text-sm max-w-md">
            Descomplique sua operação! Seja no atendimento de mesa, delivery ou cozinha, nós facilitamos a gestão do seu negócio.
          </p>
        </div>

        <div class="flex-1">
          <h3 class="text-white text-xl font-semibold mb-4">Navegação</h3>
          <ul>
            <li class="mb-2">
              <a href="#" class="hover:text-orange-500 transition-colors duration-300">Início</a>
            </li>
            <li class="mb-2">
              <a href="/quemsomos" class="hover:text-orange-500 transition-colors duration-300">Sobre Nós</a>
            </li>
            <li class="mb-2">
              <a href="#" class="hover:text-orange-500 transition-colors duration-300">Serviços</a>
            </li>
            <li class="mb-2">
              <a href="/politicaprivacidade" class="hover:text-orange-500 transition-colors duration-300">Política de
                Privacidade</a>
            </li>
          </ul>
        </div>

        <div class="flex-1">
          <h3 class="text-white text-xl font-semibold mb-4">Siga-nos</h3>
          <div class="flex space-x-4 justify-center lg:justify-start">
            <a :href=instagramLink target="_blank" aria-label="Instagram"
              class="text-gray-400 hover:text-orange-500 transition-colors duration-300">
              <font-awesome-icon :icon="['fab', 'instagram']" size="lg" />
            </a>
            <a :href=linkedinLink target="_blank" aria-label="LinkedIn"
              class="text-gray-400 hover:text-orange-500 transition-colors duration-300">
              <font-awesome-icon :icon="['fab', 'linkedin-in']" size="lg" />
            </a>
          </div>
        </div>
      </div>

      <div class="border-t border-gray-700 mt-12 pt-4 text-center text-sm">
        <p>&copy; 2026 OVERX. Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

import {
  INSTAGRAM_LINK,
  LINKEDIN_LINK,
} from '@/config/links';

library.add(faFacebookF, faTwitter, faInstagram, faLinkedinIn);

export default {
  name: "FooterPage",
  data() {
    return {
      linkedinLink: LINKEDIN_LINK,
      instagramLink: INSTAGRAM_LINK
    };
  },
  components: {
    FontAwesomeIcon,
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

input::placeholder {
  color: #a1a1aa;
}

@media (max-width: 1024px) {
  .flex-1:last-child .flex {
    justify-content: center;
  }
}

form {
  width: 100%;
}

input {
  flex: 1;
}

button {
  flex-shrink: 0;
}
</style>
